// iFrameResize
jQuery(function ($) {
    try {
        iFrameResize({
            log: false,
            checkOrigin: false,
            onResized: ({iframe}) => {
                $(document).trigger('iframe-resize/ready');
                // On mobile/tablet, center the iframe on form submission
                if (window.innerWidth < 992 && iframe.offsetHeight < 100) {
                    iframe.scrollIntoView({block: "center"});
                }
            },
        });
    } catch (e) {
    }
});